import Screen from '../Screen';
import React, { FC, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import textAPI from 'api/textAPI';
import { getTestKey } from 'config/sources';
import { DEFAULT_TOEIC_YEAR } from 'config/defaultYear';
import CryptoJS from 'crypto-js';
import Part6Item from './shared/Part6Item';
import Footer from 'components/Footer';
import { getPart } from 'store/selectors/selectors';
import { updatePartAction } from 'store/actionTypes/actionType';
import { useDispatch, useSelector } from 'react-redux';
import { TestFlatList } from 'components/TestFlatList';

const Part6: FC = () => {
  const [testList, setTestList] = useState<any[]>([]);
  const [correctNumber, setCorrectNumber] = useState<number>(-1);
  const [totalNumber, setTotalNumber] = useState<number>(-1);

  const history = useHistory();
  const dispatch = useDispatch();
  const { testNumber, year } = useParams();
  const testName = getTestKey(year, testNumber);
  const part  = useSelector(getPart(testName, 'part6'));
  useEffect(() => {
    getData(testNumber, part);
  }, []);

  const getData = async (testNumber: number, part: any) => {
    const itemTypes: any[] = (part && part.questions && part.questions.length > 0) ? part.questions : [];
    if (itemTypes.length > 0) {
      setTestList(itemTypes);
    } else {
      const data = await textAPI.get(year, testNumber, 6);
      const plainData = CryptoJS.AES.decrypt(data, 'thieumao').toString(CryptoJS.enc.Utf8);
      const json = JSON.parse(plainData);
      setTestList(json);
      updateDatabase(testName, json);
    }
  };

  const updateDatabase = async (testName: string, partQuestions: any[]) => {
    const partDetail = {
      name: 'Part 6',
      questions: partQuestions,
    };
    dispatch(updatePartAction(testName, 'part6', partDetail));
  };

  const onOpenDetail = (data: any, part6Index: number) => {
    history.push(`/toeic${year || DEFAULT_TOEIC_YEAR}/test${testNumber}/part6/question${part6Index + 1}`);
  };

  const onSelectAnswer = (detailItem: any, questionPosition: number, selected: string, part6Index: number) => {
    let arr = testList || [];
    if (arr[part6Index].questions[questionPosition].selected != selected) {
      arr[part6Index].questions[questionPosition].selected = selected;
    } else {
      arr[part6Index].questions[questionPosition].selected = undefined;
    }
    updateDatabase(testName, arr);
  };

  const onReset = () => {
    let arr = testList || [];
    for (let test of arr) {
      test.isShownTranslate = false;
      const questions = (test.questions) ? test.questions : [];
      for (const question of questions) {
        const item = question;
        if (item) {
          item.submitted = false;
          item.selected = false;
        }
      }
    }
    updateDatabase(testName, arr);

    setCorrectNumber(-1);
  };

  const onSubmit = () => {
    calculateScore();
    let arr = testList || [];
    for (let test of arr) {
      const questions = (test.questions) ? test.questions : [];
      for (const question of questions) {
        const item = question;
        if (item && item.selected) {
          test.isShownTranslate = true;
          item.submitted = true;
        }
      }
    }
    updateDatabase(testName, arr);
  };

  const calculateScore = () => {
    let correctCount = 0;
    let count = 0;
    for (const test of testList) {
      const questions = (test.questions) ? test.questions : []; 
      for (const question of questions) {
        count += 1;
        const item = question;
        if (item && item.selected) {
          if (item.selected == item.correct) {
            correctCount += 1;
          } else {
          }
        } else {
        }
      }
    }
    setCorrectNumber(correctCount);
    setTotalNumber(count);
  };

  const renderItem = ({ index }: { item: any; index: number }) => {
    const item = testList[index];
    return (
      <Part6Item
        data={item}
        part6Index={index}
        onOpenDetail={onOpenDetail}
        onSelectAnswer={onSelectAnswer}
        onCollapse={() => null}
        onCollapseTranslation={() => null}
      />
    );
  };

  return (
      <Screen canBack title={`Test ${testNumber} - Part 6`} showMenu={false} showScrollToTop showScrollToBottom isLoading={!testList.length}>
        <TestFlatList
          data={testList}
          renderItem={renderItem}
          keyExtractor={(item, index) => `${index}_${item}`}
        />
        <Footer correctNumber={correctNumber} totalNumber={totalNumber} onReset={onReset} onSubmit={onSubmit} />
      </Screen>
  );
};

export default Part6;
